import React from 'react';
import { ScrollView, View, Text, StyleSheet } from 'react-native';

const LawScreen = () => {
  return (
    <View style={styles.container}>

    <ScrollView contentContainerStyle={{ padding: 16 }}>
      <View style={styles.systtlA}>
        <View style={styles.separator} />
        <Text style={styles.termstitle}>特定商取引法に基づく表記</Text>
        <View style={styles.separator} />

        <View style={styles.textRow}>
          <Text style={styles.textb}>販売事業者</Text>
          <Text style={styles.textc}>株式会社黒瀬ペットフード</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>代表者</Text>
          <Text style={styles.textc}>代表取締役 〇〇 〇〇</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>所在地</Text>
          <Text style={styles.textc}>〒720-2124 広島県福山市神辺町川南396-1</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>電話番号</Text>
          <Text style={styles.textc}>084-962-1234</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>メールアドレス</Text>
          <Text style={styles.textc}>appmaster@kurose-pf.co.jp</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>サービス名</Text>
          <Text style={styles.textc}>愛鳥ノート とりにてぃ プレミアム会員サービス</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>販売価格</Text>
          <Text style={styles.textc}>月額200円（税込）</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>商品代金以外の必要料金</Text>
          <Text style={styles.textc}>なし</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>支払方法</Text>
          <Text style={styles.textc}>クレジットカード決済（Stripe）</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>支払時期</Text>
          <Text style={styles.textc}>初回登録時および以降は毎月同日に自動更新・課金</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>申込の有効期限</Text>
          <Text style={styles.textc}>なし（自動継続）</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>サービス提供時期</Text>
          <Text style={styles.textc}>決済完了後、即時にプレミアム機能利用可能</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>解約方法</Text>
          <Text style={styles.textc}>ウェブサービス内の設定画面からご自身で手続き。解約後も当月末まで利用可</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>返金について</Text>
          <Text style={styles.textc}>解約後の月額料金の返金はいたしかねます</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>動作環境</Text>
          <Text style={styles.textc}>インターネット接続必須</Text>
        </View>
        <View style={styles.textRow}>
          <Text style={styles.textb}>表示価格</Text>
          <Text style={styles.textc}>表示価格はすべて税込です</Text>
        </View>

      </View>
    </ScrollView>


      <View style={styles.footer}></View>

    </View>
  );
};


const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    justifyContent: 'center',
    flex: 1,
    padding: 20,
  },
  header: {
    // ヘッダースタイル
  },
  separator: {
    marginTop: 10,
    marginBottom: 14,
    borderBottomColor: '#bbb',
    borderBottomWidth: 1,
  },
  headerinr: {
    fontSize: 24,
    fontWeight: 'bold',
    padding: 3,
    color: '#777',
  },
  systtlA: {
    // 規約セクションのスタイル
  },
  termstitle: {
    fontSize: 20,
    fontWeight: 'bold',
    padding: 3,
    color: '#777',
  },
  texta: {
    textAlign: 'left',
    fontSize: 14,
    color: '#777',
    padding: 14,
  },
  textb: {
    textAlign: 'left',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#777',
    padding: 4,
  },
  textc: {
    textAlign: 'left',
    fontSize: 14,
    color: '#777',
    padding: 4,
    width: '97%',
  },
  textRow: {
    flexDirection: 'row',
    width: '100%',
    padding: 5,
  },
  footer: {
    // フッタースタイル
  },
});

export default LawScreen;
